const DIRECTIONS = {
  RIGHT: 'right',
  LEFT: 'left',
};

const ARROW_SIZES = {
  DEFAULT: {
    BUTTON_LENGTH: 36,
    ARROW_LENGTH: 15,
    LINE_LENGTH: 2,
  },
  MEDIUM: {
    BUTTON_LENGTH: 27,
    ARROW_LENGTH: 11,
    LINE_LENGTH: 2,
  },
};

export { DIRECTIONS, ARROW_SIZES };

export default DIRECTIONS;
